var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('v-image',{attrs:{"src":"/images/icons/no_content.png"}}),_c('p',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"blue"},[_vm._v("【切换城市】")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }